module.exports = __webpack_public_path__ + "img/d06683364e0883a9068fa0dd85069c64.png";